export const TEST_VARIATION_A = 'test_variation_a';
export const TEST_VARIATION_B = 'test_variation_b';
export const TEST_VARIATION_C = 'test_variation_c';

export const getTestVariation = (abTests, testNumber) => {
    const val = abTests[testNumber];

    if (typeof val === 'undefined' || val === '1') {
        return TEST_VARIATION_A;
    } else if (val === '2') {
        return TEST_VARIATION_B;
    } else {
        return TEST_VARIATION_C;
    }
};
